import { UI, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { DirectTreasuryApplicationProps } from '../..';
import { InputMoney } from '../../../../../../../../../../components/InputMoney';
import { useRecoilQuery } from '../../../../../../../../../../hooks/useRecoilQuery';
import { directTreasuryMarketStatusQuery } from '../../../../../../../../../../store/product/selectors';
import { DirectTreasuryController } from '../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/DirectTreasury';
import { ProductCard } from '../../../../components/ProductCard';

export interface DirectTreasuryInvestCardProps {
  offer: DirectTreasuryApplicationProps['offer'];
  offerController: DirectTreasuryController;
}

export const DirectTreasuryInvestCard: React.FC<DirectTreasuryInvestCardProps> = ({
  offer,
  offerController,
}) => {
  const { data: marketStatus, loading } = useRecoilQuery(directTreasuryMarketStatusQuery);

  const id = offer.productIdNormalized;

  const {
    control,
    amountItem,
    currentValueFormatted,
    handleChangeAmountItem,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
  } = offerController;

  return (
    <ProductCard
      infos={[
        { label: 'Data de aplicação', value: offer.settlementDateFormattedNormalized },
        { label: 'Aplicação', value: offer.settlementPeriodFormattedNormalized },
        {
          label: 'Investimento mínimo',
          value: Utils.Mask.Money(offer.minimumApplication || 0),
        },
        {
          label: 'Horário limite',
          value: marketStatus?.originalData?.marketStatus?.finishHour || '--',
          loading,
        },
        { label: 'Preço unitário', value: Utils.Mask.Money(offer.purchasePrice || 0) },
      ]}
      productColor="product.tesouro"
      title={offer.productNameNormalized}
      BottomComponent={
        <VStack space="stack.xxxs">
          <VStack>
            <UI.Text color="neutral.black" variant="semibold">
              Quantidade Desejada
            </UI.Text>
            <UI.InputStepper
              stepperValue={0.01}
              max={1000000}
              min={offer.minimumStepQuantity || 0}
              name="treasury-amount-order-input"
              testId="treasury-amount-order-input"
              keyboardType="numeric"
              fontSize={Typography['fontsize.md']}
              defaultValue={amountItem || 0}
              onChange={handleChangeAmountItem}
              showErrorMessage={false}
            />
          </VStack>
          <VStack>
            <UI.Text color="neutral.black" variant="semibold">
              Valor a aplicar
            </UI.Text>
            <InputMoney
              id={`directTreasury-input${id}`}
              name="priceItem"
              control={control}
              handleFocus={handleInputFocus}
              handleBlur={handleInputBlur}
              handleSubmit={handleSubmit}
              handleClear={handleInputClear}
              currentValue={currentValueFormatted}
              hasFocus={isFocused}
              minValue={offer.minimumApplication || 0}
              customInputProps={{
                ...{
                  ...(showMessageAdjustUnitPrice && {
                    helpTextProps,
                    helpText,
                  }),
                },
                ...{ ...(isFocused && hasError && { error: hasError }) },
                ...{ ...(isFocused && !hasError && { helpText }) },
              }}
            />
          </VStack>
        </VStack>
      }
    />
  );
};
